import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";
import Form from "../components/Form";

const FixedDeposit = () => {
  return (
    <>
      <TopBanner content={"Fixed Deposit"} />
      <ContentWrapper>
        <div className="text-content">
          <h2>Simple, Safe & Steady Growth</h2>
          <p>
            Fixed Deposits (FDs) are one of the most popular savings options in
            India. You invest a lump sum amount for a fixed period and earn
            guaranteed interest making it a great choice for conservative
            investors who prefer safety over risk.
          </p>
          <p>
            Whether you’re saving for a short-term goal or just want to keep
            your money secure, FDs offer stability, predictable returns, and
            easy access to funds when needed.{" "}
          </p>

          <h3>Why Fixed Deposits?</h3>
          <ul>
            <li>Guaranteed returns with zero market risk</li>
            <li>Flexible tenure from 7 days to 10 years</li>
            <li>Choose between monthly or lump sum interest payouts</li>
            <li>Easy to open at any bank or NBFC</li>
            <li>Ideal for emergency funds or low-risk savings</li>
          </ul>
        </div>
        <Form />
      </ContentWrapper>
    </>
  );
};

export default FixedDeposit;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 100px;
  gap: 20px;

  .text-content {
    width: 50%;
    p,
    ul,
    li {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #333;
      text-align: left;
    }
  }

  h3 {
    color: black;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 30px;

    .text-content {
      width: 100%;
    }
  }
`;
